// @intent: Persisted chat message payloads and LLM context message contract for TZ section 3.10
// @flow: services/agent writes AgentMessageContent; assembleLLMContext returns LLMContextMessage[]
// @stale: When tool call/result payloads become strongly typed by ToolRegistry in R2

import { z } from 'zod';

export const AgentMessageContentSchema = z.object({
  version: z.literal('v1'),
  text: z.string(),
  toolCalls: z.array(z.object({
    id: z.string(),
    name: z.string(),
    arguments: z.unknown(),
  })).optional(),
  toolCallId: z.string().optional(),
  toolResult: z.object({
    ok: z.boolean(),
    errors: z.array(z.unknown()).optional(),
  }).optional(),
}).superRefine((content, ctx) => {
  if (content.toolResult && !content.toolCallId) {
    ctx.addIssue({
      code: 'custom',
      path: ['toolCallId'],
      message: 'tool result content requires the matching toolCallId',
    });
  }
});
export type AgentMessageContent = z.infer<typeof AgentMessageContentSchema>;

export const LLMContextMessageSchema = z.object({
  role: z.enum(['system', 'user', 'assistant', 'tool']),
  content: z.string(),
  tool_call_id: z.string().optional(),
  tool_calls: z.array(z.object({
    id: z.string(),
    type: z.literal('function'),
    function: z.object({
      name: z.string(),
      arguments: z.string(),
    }),
  })).optional(),
});
export type LLMContextMessage = z.infer<typeof LLMContextMessageSchema>;
